import type { QuoteDocument } from 'paintscout'

export function setDates(args: {
  quote: QuoteDocument
  client?: { accepted?: number; declined?: number; sent?: number; viewed?: number }
  staff?: { accepted?: number; declined?: number; sent?: number; viewed?: number }
  updated?: number
}) {
  return {
    ...args.quote,
    dates: {
      ...args.quote.dates,
      client: {
        ...(args.quote.dates.client || {}),
        ...(args.client || {})
      },
      staff: {
        ...(args.quote.dates.staff || {}),
        ...(args.staff || {})
      },
      updated: typeof args.updated !== 'undefined' ? args.updated : args.quote.dates.updated
    }
  }
}
